var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ThumbsUpPlusIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 43,
    glyphHeight: 53
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.1786 49.9891H27.0856L27.0968 50C31.9148 50 36.185 46.968 37.7053 42.4581L42.6462 27.8199C43.3393 25.7768 43.0039 23.6034 41.7296 21.8538C40.4552 20.1041 38.4654 19.1043 36.2856 19.1043H22.9943L25.6436 8.63915C26.5714 4.97688 24.414 1.30374 20.7474 0.271351C17.7851 -0.565429 14.6439 0.575635 12.9448 3.10771C0 22.3645 0 25.7225 0 26.8201V38.9588C0 45.0445 5.01917 49.9891 11.1786 49.9891ZM16.6561 5.54198C17.1479 4.82474 17.9528 4.41178 18.7912 4.41178L18.78 4.42265C19.0259 4.42265 19.2607 4.45525 19.4954 4.52045C20.8368 4.90081 21.6193 6.23748 21.284 7.57416L17.2485 23.5165H36.2632C36.9898 23.5165 37.6494 23.8425 38.0742 24.4293C38.499 25.0161 38.6107 25.7334 38.376 26.418L33.4351 41.0562C32.5184 43.7622 29.9697 45.577 27.0745 45.577H11.1674C7.46728 45.577 4.46024 42.6103 4.46024 38.9588V26.8201C4.4826 25.6138 7.07603 19.789 16.6561 5.54198ZM20.3677 41.2954C21.5973 41.2954 22.6034 40.3173 22.6034 39.1219V36.9486H24.839C26.0687 36.9486 27.0747 35.9706 27.0747 34.7752C27.0747 33.5798 26.0687 32.6017 24.839 32.6017H22.6034V30.4281C22.6034 29.2327 21.5973 28.2546 20.3677 28.2546C19.138 28.2546 18.1319 29.2327 18.1319 30.4281V32.6017H15.8962C14.6665 32.6017 13.6605 33.5798 13.6605 34.7752C13.6605 35.9706 14.6665 36.9486 15.8962 36.9486H18.1319V39.1219C18.1319 40.3173 19.138 41.2954 20.3677 41.2954Z",
    fill: "black"
  }));
};
export var ThumbsUpPlusIconGlyph = function (props) {
  return React.createElement(ThumbsUpPlusIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};